import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import RouteApi from "../Backend/Backend";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify"; // Import Toastify for notifications
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { CountdownCircleTimer } from "react-countdown-circle-timer";


const Start = () => {

  const schoolname = localStorage.getItem("schoolname");

  const { id } = useParams(); // Retrieve the dynamic id from the route params
  const navigate = useNavigate();

  const [selected, setSelected] = useState(null); // for objective answers
  const [theoryAnswers, setTheoryAnswers] = useState(null); // for theory answers

  useEffect(() => {
    const handlePopState = (e) => {
      // Force forward navigation if user tries to go back
      navigate(1); // push the user forward
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }], // Added line for sub/super
      ["blockquote", "code-block"],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const formats = [
    "header", "bold", "italic", "underline", "strike",
    "align", "list", "bullet",
    "color", "background",
    "script", // Added "script" format
    "blockquote", "code-block",
    "link", "image", "video"
  ];

  const axiosInstance = axios.create({
      baseURL: `/${id}/v3`, // Adjust base URL dynamically
      headers: {
          "Content-Type": "application/json",
      },
  });

  const location = useLocation();
  console.log("State received:", location.state);

  const { trigger, required, message, cbtId, user } = location.state || {};

  useEffect(() => {
    if (!cbtId) {
      navigate("../"+id+"/take-cbt");
    }
  }, [cbtId, navigate]);

  console.log("Trigger:", trigger);
  console.log("Message:", message);
  console.log("CBT ID:", cbtId);

  // Get user details
  const email = user?.email || ""; 
  const fname = user?.firstName || ""; 
  const studid = user?.studid || ""; 

  const { getCbtByTokenId, handleCbtColumn, handleUpdateCbtColumn, handleGetAllCbtColumns, handleGetCbtColumnById, saveStepperProgress } = RouteApi();

  const clickSoundRef = useRef(null);

  useEffect(() => {
    clickSoundRef.current = new Audio("/assets/sound/3.mp3"); // place the sound file in /public/assets/sound
  }, []);

  const playSound = () => {
    if (clickSoundRef.current) {
      clickSoundRef.current.currentTime = 0; // rewind to start
      clickSoundRef.current.play().catch((e) => {
        console.warn("Sound play failed:", e);
      });
    }
  };

  const [formData, setFormData] = useState({
    type: "",
    question: "",
    options: ["", "", "", ""],
    correctAnswer: "",
    theoryAnswer: "",
    instructionText: "",
  });
  
  const [cbtTask, setCbtTask] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCbtTaskByToken = async (cbtId) => {
    setLoading(true);
    setError(null);

    const result = await getCbtByTokenId(cbtId);
    console.log("CBT Task By Token:", result);
    
    if (result.success && result.task) {
      setCbtTask(result.task);
      console.log("CBT Title:", result.task.title); // Accessing the title
    } else {
      setCbtTask(null);
      setError("CBT task not found or failed to load.");
    }

    setLoading(false);
  };

  const [column, setColumn] = useState([]);
  const [activeColumnId, setActiveColumnId] = useState(null); // track selected column

  useEffect(() => {
    loadCbtTaskByToken(cbtId); // initial load
  }, [cbtId]);

  
  const handleFetchColumns = async () => {
    const tokenId = cbtId;

    if (!tokenId) {
      toast.error("❌ Missing CBT token ID");
      return;
    }

    const result = await handleGetAllCbtColumns(tokenId, email);

    if (result.success) {
     // toast.success("✅ Fetched all CBT columns!");
      setColumn(result.rows || []);
    } else {
      toast.error(`❌ Error Encounter! Err Message - ${result.error}`);
    }
  };

  const handleFetchColumnById = async (id) => {
    const tokenId = cbtId;

    if (!tokenId || !id) {
      toast.error("❌ Missing ID or Token ID");
      return;
    }

    const result = await handleGetCbtColumnById(id, tokenId, email);

    if (result.success) {
      //toast.success("✅ Fetched CBT column by ID!");
      setActiveColumnId(id);
      localStorage.setItem("lastSelectedCbtColumnId", id);
      await saveStepperProgress(id);

      const row = result.row;

      // Set formData from row data
      setFormData({
        type:
          row.ques_type || "",

        instructionText:
          row.ques_type === "instruction" ? row.ques || "" : "",

        question:
          row.ques_type !== "instruction" ? row.ques || "" : "",

        options: row.ques_type === "objective"
          ? [row.ans1, row.ans2, row.ans3, row.ans4].map((opt) => opt || "")
          : ["", "", "", ""],

        correctAnswer: row.anscor || "",

        theoryAnswer:
          row.ques_type === "theory" ? row.solution || "" : "",
      });
    } else {
      //toast.error(`❌ Error Encounter! Err Message - ${result.error}`);
    }
  };

  useEffect(() => {
    handleFetchColumns(); // fetch all columns

    const lastId = localStorage.getItem("lastSelectedCbtColumnId");
    if (lastId) {
      handleFetchColumnById(parseInt(lastId)); // 🔁 Restore previous selection
    }else{
      handleFetchColumnById(1); // 🔁 Restore previous selection
    }
  }, []);

  const [searchQuery, setSearchQuery] = useState("");

  // Filtered column list
  const filteredColumns = column.filter(col =>
    (col.ques_type + " " + col.ques + " " + col.ques_id)
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const swiperRef = useRef(null);

  useEffect(() => {
    if (!swiperRef.current || !filteredColumns.length || !activeColumnId) return;

    const activeIndex = filteredColumns.findIndex(col => col.row_id === activeColumnId);


    if (activeIndex !== -1) {
      swiperRef.current.slideTo(activeIndex);
    }
  }, [activeColumnId, filteredColumns]);

  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

  const examDuration = parseInt(cbtTask?.timer || "0"); // in minutes
  const timerSeconds = examDuration * 60;

  const [duration, setDuration] = useState(null); // in seconds
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!cbtTask?.timer || !cbtId || !studid) return;

    const initTimer = async () => {
      try {
        const response = await axiosInstance.post(
          "/take-cbt/get-saved-timer",
          { tokenid: cbtId, studid },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data?.status === "success") {
          const remaining = response.data.remaining;
          const backendDuration = parseInt(remaining);
          const frontendDefault = parseInt(cbtTask.timer) * 60;

          const useTime = backendDuration > 0 && backendDuration < frontendDefault
            ? backendDuration
            : frontendDefault;

          setDuration(useTime);
        }
      } catch (error) {
        setDuration(parseInt(cbtTask.timer) * 60);
      }
    };


    initTimer();
  }, [cbtTask?.timer, cbtId, studid]);

 const lastSavedRef = useRef(0); // timestamp in seconds

  const handleUpdate = (remaining) => {
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    if (remaining % 30 === 0 && now - lastSavedRef.current >= 28) {
      saveRemainingTime(remaining);
      lastSavedRef.current = now;
    }
  };

  const saveRemainingTime = async (remainingSeconds) => {
    try {
      await axiosInstance.post(
        "/take-cbt/save-timer",
        {
          tokenid: cbtId,
          studid,
          remaining: remainingSeconds,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Failed to save timer:", error);
    }
  };

  const calculateTotalScore = async () => {
    try {
      const response = await axiosInstance.post(
        "/take-cbt/calculate-score",
        {
          tokenid: cbtId,
          studid: studid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.status === "success") {
        toast.success(`✅ Submitted Successfully`);

        playSound();

        setTimeout(() => {
            navigate(`/${id}/take-cbt/home`);
        }, 2000);

      } else {
        toast.error("❌ Failed to update score.");
      }
    } catch (error) {
      console.error("Error calculating score:", error);
      toast.error("❌ Something went wrong while calculating score.");
    }
  };


  const handleMarkQuestion = async () => {
    playSound();
  
    if (!formData.type || formData.type === "instruction") return;
  
    const tokenid = cbtId;
    const row_id = activeColumnId;
  
    if (!tokenid || !row_id || !studid) {
      toast.error("❌ Missing required info to mark question.");
      return;
    }
  
    const token = localStorage.getItem("token");
  
    try {
      const response = await axiosInstance.post(
        "/take-cbt/mark-question",
        {
          tokenid,
          row_id,
          answer: formData.type === "theory" ? theoryAnswers : selected || "",
          studid: studid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const data = response.data;
  
      if (data.status === "success") {
        toast.success("✅ Question marked!");
      } else if (data.status === "skipped") {
        toast.info(`⚠️ ${data.message}`);
      } else {
        toast.error(`❌ ${data.message}`);
      }
    } catch (error) {
      console.error(error);
      toast.error("❌ Failed to mark question.");
    }
  };


  return (
    <div className="bg-back">

      <div className="fixed-top">
        <div className="bg-white" style={{ left: "300px" }}>
          <div className="row d-flex px-4">
            <div className="d-none d-lg-flex col-lg-3">
            <div className="py-4">
              <div className="fs-t text-purple2 fw-medium">
                {schoolname}
              </div>
             </div>
            </div>

            <div className="col-lg-6 col-9 ms-lg-n6">
              <div className="py-4">
              <div className="fs-t text-dark fw-medium">
                Good Luck! {fname}
              </div>
             </div>
            </div>

            <div className="col-lg-3 col-3 text-end ms-lg-4">
              <div className="pt-3">
                <button onClick={() => calculateTotalScore()}
                className="btn btn-dark btn-lg rounded-pill">
                  <i className="bi bi-check2-all"></i> Submit
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
     
      {loading ? (
        <>
        {!isMobile ?
          <div
            className="sidebar-loader bg-white p-4"
            style={{
              width: "300px",
              height: "100vh",
              overflowY: "auto",
              borderRight: "1px solid #eee",
            }}
          >
            <div className="mt-16">
            {[...Array(5)].map((_, i) => (
              <Skeleton
                key={i}
                height={35}
                className="mb-3 py-5"
                style={{ borderRadius: "10px" }}
              />
            ))}
          </div>
          </div>
          :
          <></>
          }
          <Skeleton height={40} className="mb-3" />
        </>
      ) : (
      <>
      {isMobile ?
      <></>
      :
      <div
        class="docs-nav-sidebar border-none bg-white shadow-none"
        style={{ width: "300px", border: "none", height: "700px" }}
      >
        <div class="py-5">
          
        </div>
        
        <div class="nav-top border-0 py-0 mt-6">
          <nav class="navigation navbar navbar-expand-lg px-4">
              <div class="collapse navbar-collapse mb-0" id="navbarNav">
                <div className="col-lg-12 mb-3">
                <input
                  type="text"
                  className="form-control form-control-md rounded-4 bg-light text-dark"
                  placeholder="Filter Search Columns"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </nav>
        </div>
        <div class=" docs-nav" data-simplebar>
          <nav class="navigation navbar navbar-expand-lg">
            <div class="collapse navbar-collapse mb-0" id="navbarNav">
              <ul
                class="navbar-nav flex-column text-start px-4 shadow-none mb-15"
                id="sidebarnav"
              >
                {column.length > 0 ? (
                  <>
                    <li className="mt-2 mb-3 bg-transparent">
                      <div className="text-start text-dark fs-3">Question List</div>
                    </li>

                    {[...filteredColumns].reverse().map((col, index) => {
                      const stripHtml = (html) => {
                        const doc = new DOMParser().parseFromString(html, 'text/html');
                        return doc.body.textContent || "";
                      };

                      const shortQues = col.ques
                        ? stripHtml(col.ques).split(" ").slice(0, 12).join(" ") + "..."
                        : "No question set yet...";

                      const isActive = activeColumnId === col.row_id;

                      const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

                      return (
                        <li
                          key={col.row_id}
                          className={`card ${isActive ? "bg-purple4" : "bg-back"} shadow-none cursor-pointer mb-4`}
                          onClick={() => handleFetchColumnById(col.row_id)}
                        >
                          <div className={`row px-3 py-2 ${isActive ? "text-white" : "text-dark"}`}>
                            <div className="col-8">
                            <i className={`bi bi-bullseye fs-4 ${isActive ? "text-white" : "text-purple4"}`}></i>
                            <span className="col fs-4 ms-2">
                              {col.ques_type === "instruction" || col.ques_type === "theory"
                                ? `${capitalize(col.ques_type)}`
                                : col.ques_type === "objective"
                                ? `${capitalize(col.ques_type)} ${col.row_id -1}`
                                : `New Column`}
                            </span>
                            </div>

                            <div className="px-4 mt-2">
                              <span className={`fs-5 ${isActive ? "text-white" : "text-dark"}`}>
                                {shortQues}
                              </span>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <li className="col-12 text-center py-20 px-4">
                      <div className="text-gray-700 fs-5 mt-3">
                        <i className="bi bi-stars text-warning fs-3"></i> Smart Ai -{" "}
                        <span className="text-dark fw-medium">
                          Hey there! Nothing to worry just call the attention of you teacher or school admin.
                        </span>
                      </div>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </nav>
        </div>
      </div>
      }

      <div
        className="docs-wrapper bg-back py-lg-10 py-5"
        style={isMobile ? {} : { left: "50px", width: "calc(100% - 300px)" }}
      >
        <div className="position-relative overflow-hidden px-0 px-lg-4 bg-dark mt-lg-n5 mt-5 pb-5 pb-lg-5">
         
          <div className="container py-lg-4">
            <div className="pt-6">
              <div className="row px-lg-5 px-md-4 px-4 align-items-center">
                <div className="col-lg-8 mb-4 mb-lg-0 mt-n4">
                  <div className="text-white fs-t fw-medium">
                    <i class="bi bi-laptop-fill"></i>{" "}
                    {loading ? (
                      <Skeleton width={200} height={24} baseColor="#dddddd" highlightColor="#f3f3f3" />
                    ) : (
                      <></>
                    )}
                    {cbtTask?.cbt_subject}
                  </div>
                  <div className="fs-4 text-white">
                     {cbtTask?.cbt_class}
                  </div>
                </div>

                <div className="col-lg-4 d-flex justify-content-end align-items-center">
                  {duration !== null && (
                    <CountdownCircleTimer
                      isPlaying
                      duration={duration}
                      colors={["#27ae60", "#f39c12", "#c0392b"]}
                      colorsTime={[duration, duration / 2, 0]}
                      size={150}
                      strokeWidth={8}
                      onUpdate={handleUpdate}
                      onComplete={() => {
                        toast.info("⏰ Time's up!");
                        // auto-submit or redirect logic
                        calculateTotalScore();
                      }}
                    >
                      {({ remainingTime }) => {
                        const minutes = Math.floor(remainingTime / 60);
                        const seconds = remainingTime % 60;
                        return (
                          <div className="text-white text-center fs-3">
                            <div className="fw-medium">
                              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                            </div>
                          </div>
                        );
                      }}
                    </CountdownCircleTimer>
                  )}

                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="container py-5 px-lg-14 px-2">
          <div className="col-12 mt-n9">
            <div
              className="card shadow-none bg-white"
              style={{ borderRadius: "30px" }}
            >
              <div className="px-lg-8 py-lg-4 px-6 py-4">
                {formData?.type && (
                  <div className="row gx-4 gy-6">

                     {/* INSTRUCTION */}
                     {formData.type === "instruction" && (
                      <div className="col-12 mb-4">
                        <div className="fs-3 fw-semibold text-dark mb-3">
                          Instruction:
                        </div>
                        {
                          /\.(jpeg|jpg|png|gif|webp|bmp)$/i.test(formData.instructionText?.trim()) ? (
                            <div className="mt-2">
                              <img
                                src={formData.instructionText.trim()}
                                alt="Instruction Image"
                                style={{ maxWidth: "100%", borderRadius: "12px" }}
                              />
                            </div>
                          ) : (
                            <div
                              className="fs-4 text-dark"
                              dangerouslySetInnerHTML={{ __html: formData.instructionText }}
                            />
                          )
                        }
                      </div>
                    )}

                    {/* THEORY */}
                    {formData.type === "theory" && (
                      <div className="col-12 mb-4">
                        <div className="fs-4 fw-semibold text-dark mb-3">
                          {activeColumnId - 1}.
                          {
                            // If it's an image path
                            /\.(jpeg|jpg|png|gif|webp|bmp)$/i.test(formData.question?.trim()) ? (
                              <div className="mt-2">
                                <img
                                  src={formData.question.trim()}
                                  alt="Question Image"
                                  style={{ maxWidth: "100%", borderRadius: "12px" }}
                                />
                              </div>
                            ) : (
                              // Else show as HTML/text
                              <span
                                className="ms-2"
                                dangerouslySetInnerHTML={{ __html: formData.question }}
                              />
                            )
                          }
                        </div>

                        <ReactQuill
                          theme="snow"
                          value={theoryAnswers}
                          onChange={(value) => setTheoryAnswers(value)}
                          modules={modules}
                          formats={formats}
                          placeholder="Write your answer here..."
                          className="form-control form-control-lg rounded-4 bg-back text-dark quill-no-border"
                        />

                      </div>
                    )}

                    {/* OBJECTIVE */}
                    {formData.type === "objective" && (
                      <>
                        <div className="col-12 pt-3">
                          <div className="fs-3 fw-semibold text-dark">
                            {activeColumnId - 1}.{" "}
                            {
                              /\.(jpeg|jpg|png|gif|webp|bmp)$/i.test(formData.question?.trim()) ? (
                                <img
                                  src={formData.question.trim()}
                                  alt="Question Image"
                                  style={{ maxWidth: "100%", borderRadius: "12px" }}
                                />
                              ) : (
                                <span
                                  className="question-content"
                                  dangerouslySetInnerHTML={{ __html: formData.question }}
                                />
                              )
                            }
                          </div>
                        </div>

                        {formData.options.map((opt, i) =>
                          opt ? (
                            <div
                              className="col-6"
                              key={i}
                              onClick={() => setSelected(opt)}
                            >
                              <div
                                className={`card cursor-pointer shadow-sm py-4 px-4 ${
                                  selected === opt ? "bg-purple text-white" : "bg-back text-dark"
                                }`}
                                style={{ borderRadius: "20px" }}
                              >
                                <div className="fs-4">
                                  {String.fromCharCode(65 + i)}. {opt}
                                </div>
                              </div>
                            </div>
                          ) : null
                        )}
                      </>
                    )}

                  </div>
                )}

                {formData?.type && (
                    <div className="row mt-7 pb-3">
                      <div className="col-6 text-start">
                        {activeColumnId > 1 && (
                          <button
                            className="btn btn-light border px-5 py-2 rounded-pill fs-5"
                            onClick={() => handleFetchColumnById(activeColumnId - 1)}
                          >
                            <i className="bi bi-arrow-left-circle me-2"></i> Previous
                          </button>
                        )}
                      </div>

                      <div className="col-6 text-end">
                        {activeColumnId < column.length ? (
                          <button
                            className="btn btn-purple text-white px-5 py-2 rounded-pill fs-5"
                            onClick={async () => {
                              const isTheory = formData.type === "theory";
                            
                              const hasAnswer = isTheory
                                ? theoryAnswers && theoryAnswers.trim() !== ""
                                : selected && selected !== "";
                            
                              if (!hasAnswer) {
                                handleFetchColumnById(activeColumnId + 1);
                                setSelected("");
                                setTheoryAnswers("");
                                return;
                              }
                            
                              await handleMarkQuestion();
                              handleFetchColumnById(activeColumnId + 1);
                              setSelected("");
                              setTheoryAnswers("");
                            }}                            
                          >
                            Next <i className="bi bi-arrow-right-circle ms-2"></i>
                          </button>
                        ) : (
                          <button
                            className="btn btn-success text-white px-5 py-2 rounded-pill fs-5"
                            onClick={async () => {
                              const isTheory = formData.type === "theory";
                            
                              const hasAnswer = isTheory
                                ? theoryAnswers && theoryAnswers.trim() !== ""
                                : selected && selected !== "";
                            
                              if (hasAnswer) {
                                await handleMarkQuestion();
                              }
                            
                              toast.success("✅ CBT Completed!");
                            }}                            
                          >
                            Finish <i className="bi bi-check-circle ms-2"></i>
                          </button>
                        )}
                      </div>
                    </div>
                )}



              </div>
            </div>
          </div>

          {column.length && isMobile > 0 ? (
            <>
              <div className="px-4 mt-6 mb-3 bg-transparent">
                <div className="text-start text-dark fs-t">Question List</div>
              </div>

              <div className="px-4">
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                grabCursor={true}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                breakpoints={{
                  640: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
                style={{ paddingBottom: "40px" }}
              >
                {[...filteredColumns].map((col, index) => {
                  const stripHtml = (html) => {
                    const doc = new DOMParser().parseFromString(html, "text/html");
                    return doc.body.textContent || "";
                  };

                  const shortQues = col.ques
                    ? stripHtml(col.ques).split(" ").slice(0, 12).join(" ") + "..."
                    : "No question set yet...";

                  const isActive = activeColumnId === col.row_id;

                  return (
                    <SwiperSlide key={col.row_id}>
                      <div
                        className={`card ${isActive ? "bg-purple4" : "bg-back"} shadow-none cursor-pointer mb-4`}
                        onClick={() => handleFetchColumnById(col.row_id)}
                        style={{
                          borderRadius: "20px",
                          color: "white",
                        }}
                      >
                        <div className={`row px-3 py-2 ${isActive ? "text-white" : "text-dark"}`}>
                          <div className="col-8 d-flex align-items-center">
                            <i className={`bi bi-bullseye fs-4 ${isActive ? "text-white" : "text-purple4"}`}></i>
                            <span className="col fs-4 ms-2">
                              {col.ques_type === "instruction" || col.ques_type === "theory"
                                ? `${capitalize(col.ques_type)}`
                                : col.ques_type === "objective"
                                ? `${capitalize(col.ques_type)} ${col.row_id - 1}`
                                : `New Column`}
                            </span>
                          </div>

                          <div className="px-4 mt-2">
                            <span className={`fs-5 ${isActive ? "text-white" : "text-dark"}`}>
                              {shortQues}
                            </span>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              </div>

              <div className="col-12 px-4 mb-8 text-center mt-n6">
                <div className="row d-flex">
                  <button className="btn btn-transparent col-2" onClick={() => swiperRef.current?.slidePrev()}>
                    <i className="bi bi-arrow-left text-dark fs-t"></i>
                  </button>
                  <div className="col-8 mt-3">
                    <span className="fs-4 text-dark"> Swipe </span>
                  </div>
                  <button className="btn btn-transparent col-2" onClick={() => swiperRef.current?.slideNext()}>
                    <i className="bi bi-arrow-right text-dark fs-t"></i>
                  </button>
                </div>
              </div>

              <>
                <li className="col-12 text-center py-4 px-4">
                  <div className="text-gray-700 fs-5 mt-3">
                    <i className="bi bi-stars text-warning fs-3"></i> Smart Ai -{" "}
                    <span className="text-dark fw-medium">
                      Hey there! You know you can use Smart Ai to help with questions!
                    </span>
                  </div>
                  <div className="mt-6">
                    <button className="btn btn-purple rounded-pill text-white" data-bs-toggle="offcanvas"
                      data-bs-target="#smart-ai"
                      aria-controls="smart-ai">
                      <i className="bi bi-stars text-warning fs-3"></i> Ask Smart Ai
                    </button>
                  </div>
                </li>
              </>
            </>
            ) : (
              <>
                <li className="col-12 text-center py-4 px-4">
                  <div className="text-gray-700 fs-5 mt-3">
                    <i className="bi bi-stars text-warning fs-3"></i> Smart Ai -{" "}
                    <span className="text-dark fw-medium">
                      Select an answer before clicking <b>Next</b>. To skip without answering, just click <b>Next</b>.
                    </span>
                  </div>
                </li>
              </>
            )
          }

        </div>
      </div>

     
      </>
      )}

     
    </div>
  );
};

export default Start;
